import { css } from '@emotion/react';
import isObject from 'lodash/isObject';
import { ifRtl } from './ifRtl.js';
import { propsEvalOrReturn } from './propsEvalOrReturn.js';

function parseSpacing(value) {
  if (value === undefined) return 'inherit';
  if (typeof value === 'string') return value;
  return "".concat(value, "px");
}

function spacing(property, argumentSpacingValue) {
  return function (props) {
    var spacingValue = propsEvalOrReturn(argumentSpacingValue, props);
    var top;
    var bottom;
    var left;
    var right;

    if (!isObject(spacingValue)) {
      top = spacingValue;
      bottom = spacingValue;
      left = spacingValue;
      right = spacingValue;
    } else {
      top = spacingValue.top;
      bottom = spacingValue.bottom;
      right = spacingValue.right;
      left = spacingValue.left;
    }

    if (top === bottom && bottom === right && right === left) {
      return /*#__PURE__*/css(property, ":", parseSpacing(top), ";");
    }

    var _ifRtl = ifRtl({
      left: right,
      right: left
    }, {
      left: left,
      right: right
    })(props),
        leftSpacing = _ifRtl.left,
        rightSpacing = _ifRtl.right;

    var args = [];

    if (top !== undefined) {
      args.push("".concat(property, "-top:").concat(parseSpacing(top), ";"));
    }

    if (rightSpacing !== undefined) {
      args.push("".concat(property, "-right:").concat(parseSpacing(rightSpacing), ";"));
    }

    if (bottom !== undefined) {
      args.push("".concat(property, "-bottom:").concat(parseSpacing(bottom), ";"));
    }

    if (leftSpacing !== undefined) {
      args.push("".concat(property, "-left:").concat(parseSpacing(leftSpacing), ";"));
    }

    return /*#__PURE__*/css.apply(void 0, args);
  };
}

function padding(value) {
  return spacing('padding', value);
}

function margin(value) {
  return spacing('margin', value);
}

export { margin, padding, parseSpacing };
